import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Select from "../../../../components/form/select/Select";
import PageTitle from "../../../../components/partials/PageTitle";
import * as yup from "yup";
import {
  createCover,
  resetCoverStatus,
} from "../../../../redux/slice/cover/coverSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MultiSelect from "../../../../components/form/select/MultiSelect";

const policies = [
  { name: "General Cover", id: "1" },
  // { name: 'Savings Policy', id: '2'},
  // { name: 'Credit Life', id: '3'},
];

const AddCover = () => {
  const [name, setName] = useState([{ cover: "" }]);
  const [nameError, setNameError] = useState("");

  const { createSuccess, all_covers } = useSelector((state) => state.cover);
  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const addName = () => {
    let obj = {
      cover: "",
    };
    setName([...name, obj]);
  };

  const removeName = (index) => {
    if (name?.length > 1) {
      let data = [...name];
      data.splice(index, 1);
      setName(data);
    }
  };

  const handleNameDetails = (e, index) => {
    let data = [...name];
    data[index].cover = e.target.value;
    setName(data);
  };

  const breadcrumb = {
    from: {
      title: "Policy Cover",
      link: "/admin/settings/cover",
    },
    current: {
      title: "Add Policy Cover",
      link: null,
    },
  };

  const onSubmit = (values) => {
    // Check if any of the cover fields are empty
    const isAnyCoverEmpty = name.some((item) => item.cover.trim() === "");

    const arr = values?.cover_name?.map((item) => ({
      cover: item?.value,
    }));

    if (isAnyCoverEmpty && values?.policy_category === "1") {
      // Display an error message or perform any other necessary actions
      setNameError("Please fill in all the cover fields.");
      return;
    } else {
      let payload = { ...values, cover_name: values?.policy_category === "1" ? [...name] : arr };
      setNameError("");
      dispatch(createCover(payload));
    }
  };

  const {
    errors,
    values,
    touched,
    handleBlur,
    handleSubmit,
    setFieldValue,
    handleChange,
    getFieldProps,
    // setFieldError,
    // resetForm,
  } = useFormik({
    // enableReinitialize: true,
    initialValues: {
      policy_category: "",
      default_rate: "",
      minimum_rate: "",
      maximum_rate: "",
      cover_name: [],
    },
    onSubmit,
    validate: (values) => {
      const errors = {};
      if (values?.policy_category === "2" && values.cover_name.length === 0) {
        errors.cover_name = "At least one policy is required";
      }
      if (values?.policy_category === "2" && !values.default_rate) {
        errors.default_rate = "Default rate is required.";
      }
      if (values?.policy_category === "2" && !values.minimum_rate) {
        errors.minimum_rate = "Minimum rate is required.";
      }
      if (values?.policy_category === "2" && !values.maximum_rate) {
        errors.maximum_rate = "Maximum rate is required.";
      }
      if (parseFloat(values?.default_rate) < parseFloat(values?.minimum_rate)) {
        errors.minMax = "Default rate cannot be less than minimum rate";
      }
      if (parseFloat(values?.default_rate) > parseFloat(values?.maximum_rate)) {
        errors.minMax = "Default rate cannot be greater than maximum rate";
      }
      if (parseFloat(values?.maximum_rate) < parseFloat(values?.minimum_rate)) {
        errors.minMax = "Minimum rate cannot be greater than maximum rate";
      }
      return errors;
    },
    validationSchema: () =>
      yup.object().shape({
        policy_category: yup.number().required("Policy Category is required"),
      }),
  });  

  const policyData = policies?.map((policy) => {
    return {
      label: policy.name,
      value: policy.id,
    };
  });

  useEffect(() => {
    if (createSuccess) {
      setName([{ cover: "" }]);
      navigate("/admin/settings/cover");
      dispatch(resetCoverStatus());
    }
  }, [createSuccess, dispatch, navigate]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "cover module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "create cover"
      )
    ) {
      navigate("/admin/dashboard");
    }
  }, [navigate, user_permissions]);

  return (
    <>
      {/* page title */}
      <PageTitle title='Add Policy Cover' breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card '>
            <form onSubmit={handleSubmit}>
              <div className='row mb-3 mt-4'>
                <div className='col-md-3 col-lg-2 text-end sm-text-end'>
                  <label htmlFor='account_type' className={`form-label mt-1`}>
                    Policy Category <span className='text-danger'>*</span>
                  </label>
                </div>

                <div className='col-md-7 col-lg-6'>
                  <Select
                    onBlur={() => {
                      handleBlur({ target: { name: "policy_category" } });
                    }}
                    name='policy_category'
                    data={policyData}
                    value={values?.policy_category}
                    onChange={(selectedOption) =>
                      setFieldValue("policy_category", selectedOption?.value)
                    }
                  />
                  {errors?.policy_category &&
                    touched?.policy_category &&
                    !values?.policy_category && (
                      <p className='mb-0 text-danger'>
                        {errors?.policy_category + "*"}
                      </p>
                    )}
                </div>
              </div>
              {values?.policy_category === "1" && <div className='row mb-2'>
                <div className='col-md-3 col-lg-2 text-right sm-text-end'>
                  <label htmlFor='name' className='col-form-label'>
                    Policy Cover Name
                    <span className='text-danger'> *</span>
                  </label>
                </div>
                <div className='col-md-5 col-lg-4'>
                  {name.map((item, index) => {
                    return (
                      <div key={index}>
                        <div className='d-flex gap-1 justify-content-center'>
                          <input
                            type='text'
                            className='form-control form-control-sm mb-1'
                            value={item?.name}
                            name={`cover[${index}]`}
                            onChange={(e) => handleNameDetails(e, index)}
                            // onBlur={handleBlur}
                          />
                          {name?.length > 1 && (
                            <div
                              className={` d-flex justify-content-end cursor-p ${
                                index === 0 ? "mt-1" : ""
                              }`}
                            >
                              <span
                                className=''
                                onClick={() => removeName(index)}
                              >
                                <i className='mdi mdi-delete text-danger fs-4 '></i>
                              </span>
                            </div>
                          )}
                        </div>
                        {index === name.length - 1 && nameError && (
                          <div className='mb-0 text-danger'>{nameError}</div>
                        )}
                      </div>
                    );
                  })}
                </div>
                <div className='col-sm-1'>
                  <button
                    type='button'
                    className='btn btn-primary btn-sm px-3 rounded d-flex justify-content-center align-items-center gap-1'
                    onClick={addName}
                  >
                    <i className='mdi mdi-plus'></i>
                    <span>Add</span>
                  </button>
                </div>
              </div>}
              {values?.policy_category === "2" && (
                <div className="row mb-2">
                  <div className="col-md-3 col-lg-2 text-right sm-text-end">
                    <label htmlFor="" className='col-form-label'>Policy Name</label>
                  </div>
                  <div className='col-md-6 col-lg-6'>
                    <MultiSelect
                      isError={
                        errors?.cover_name &&
                        touched?.cover_name &&
                        !values.cover_name.length
                      }
                      name='cover_name'
                      field={{ ...getFieldProps("cover_name") }}
                      data={all_covers?.unpaginated_cover
                        ?.map((item) => ({
                          value: item.id,
                          label: item.name,
                        }))}
                      onChange={setFieldValue}
                      onBlur={() => {
                        handleBlur({ target: { name: "cover_name" } });
                      }}
                      errors={errors}
                      touched={touched}
                      // ref={soRef}
                    />
                  </div>
                </div>
              )}
              {values?.policy_category === "2" && (
                <div>
                  <div className='row mb-2 col-lg-11 mx-auto'>
                    <div className='col-md-4 mb-3'>
                      <label htmlFor='default_rate'>
                        Default rate <span className='text-danger'>*</span>
                      </label>
                      <input
                        type='text'
                        className={`form-control ${
                          errors?.default_rate &&
                          touched?.default_rate &&
                          "is-invalid"
                        }`}
                        name='default_rate'
                        id='default_rate'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder='0.00'
                      />
                      {errors?.default_rate && touched?.default_rate && (
                        <span className='text-danger'>
                          {errors?.default_rate}
                        </span>
                      )}
                    </div>
                    <div className='col-md-4 mb-3'>
                      <label htmlFor='default_rate'>
                        Minimum rate <span className='text-danger'>*</span>
                      </label>
                      <input
                        type='text'
                        className={`form-control ${
                          errors?.minimum_rate &&
                          touched?.minimum_rate &&
                          "is-invalid"
                        }`}
                        name='minimum_rate'
                        id='minimum_rate'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder='0.00'
                      />
                      {errors?.minimum_rate && touched?.minimum_rate && (
                        <span className='text-danger'>
                          {errors?.minimum_rate}
                        </span>
                      )}
                    </div>
                    <div className='col-md-4 mb-3'>
                      <label htmlFor='default_rate'>
                        Maximum rate <span className='text-danger'>*</span>
                      </label>
                      <input
                        type='text'
                        className={`form-control ${
                          errors?.maximum_rate &&
                          touched?.maximum_rate &&
                          "is-invalid"
                        }`}
                        name='maximum_rate'
                        id='maximum_rate'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder='0.00'
                      />
                      {errors?.maximum_rate && touched?.maximum_rate && (
                        <span className='text-danger'>
                          {errors?.maximum_rate}
                        </span>
                      )}
                    </div>
                    <div className=''>
                      {errors?.minMax &&
                        touched?.maximum_interest_rate &&
                        touched?.minimum_interest_rate && (
                          <p className='alert alert-warning'>
                            {errors?.minMax}
                          </p>
                        )}
                    </div>
                  </div>
                </div>
              )}
              {values?.policy_category && (
                <div className='row mb-3 mt-3'>
                  <div className='col-md-3 col-lg-2'></div>
                  <div className='col-md-7 col-lg-6'>
                    <button
                      type='submit'
                      className='btn btn-primary btn-sm px-4 rounded'
                    >
                      <span>Create</span>
                    </button>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCover;
